import React from 'react';
import { SvgIconProps } from '@mui/material';

export const JobsIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="31"
        height="35"
        viewBox="0 0 31 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.5 22.3529V18.4706M15.5 22.3529V26.2353M15.5 22.3529H26.375C28.377 22.3529 30 20.6148 30 18.4706M15.5 22.3529H4.625C2.62297 22.3529 1 20.6148 1 18.4706M30 18.4706V30.1176C30 32.2618 28.377 34 26.375 34H4.625C2.62297 34 1 32.2618 1 30.1176V18.4706M30 18.4706V16.5294M1 18.4706V10.7059C1 8.56172 2.62297 6.82353 4.625 6.82353H26.375C28.377 6.82353 30 8.56172 30 10.7059M20.9375 6.82353V4.88235C20.9375 2.73819 19.3145 1 17.3125 1H13.6875C11.6855 1 10.0625 2.73819 10.0625 4.88235V6.82353"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default JobsIcon;
